export default __webpack_public_path__ + "static/media/unsubscribe-ban.9e97d3b9.svg";